import React, { Component } from "react";
import { Button, Glyphicon } from "react-bootstrap";
import { withRouter } from "react-router-dom";

import "./CreateHabitRow.css";

class CreateHabitRow extends Component {

  constructor(props) {
    super(props);
    this.handleHover = this.handleHover.bind(this);
    this.handleHabitClick = this.handleHabitClick.bind(this);
    this.state = {
      isHovered: false
    }
  }

  render() {
    const btnClass = this.state.isHovered ? "selected" : "";
    return (
        <tr className='CreateHabitRow'>
          <td
            onMouseEnter={this.handleHover}
            onMouseLeave={this.handleHover}
            onClick={this.handleHabitClick}
            className={ btnClass }
            href={`/habits/new`}
            >
              <b>{"\uFF0B"}</b>
          </td>
        </tr>
    );
  }

  handleHabitClick = event => {
    event.preventDefault();
    this.props.history.push(event.currentTarget.getAttribute("href"));
  }

  handleHover() {
    this.setState({
      isHovered: !this.state.isHovered
    })
  }

}
export default withRouter(CreateHabitRow);



// WEBPACK FOOTER //
// ./src/containers/CreateHabitRow.js